import React from "react";

// This is how to connect the Firebase with the React.
// Providing a Firebase instance at the top level of the component hierarchy.
const FirebaseContext = React.createContext(null);

export const withFirebase = Component => props => (
  <FirebaseContext.Consumer>
    {firebase => <Component {...props} firebase={firebase} />}
  </FirebaseContext.Consumer>
);

export default FirebaseContext;
